var ViewMode;
(function (ViewMode) {
    /** режим просмотра (по умолчанию) */
    ViewMode["view"] = "view";
    /** режим редактирования данных */
    ViewMode["edit"] = "edit";
    /** режим создания объекта данных */
    ViewMode["insert"] = "insert";
})(ViewMode || (ViewMode = {}));

export { ViewMode };
